module.exports = __webpack_public_path__ + "img/full0-min.5fc751e6.png";